/// <reference path="../../../app.definition.ts" />

import * as angular from "angular";
import { Subject } from "@common/model/subject";
import { User } from "@common/model/user";
import { IUserService } from "@common/service/user.service";

interface IEcvShareDropdown {
    displayMember(member: User): boolean;
    resetShareCallback(): void;
    selectAll(): void;
    init(): void;
}

class EcvShareDropdown implements IEcvShareDropdown {
    subject: Subject;
    callBack: Function;
    currentUserId: number;
    callbackRegistrar: Function;
    select: boolean;
    name: string;

    static $inject = ['UserService'];
    constructor(
        private $_user: IUserService
    ) { }

    resetShareCallback = () => {
        this.selectAll(false);
    }

    init(): void {
        !!this.name || (this.name = "Default");
        if (!!this.callbackRegistrar) {
            this.callbackRegistrar('ShareDropdown:' + this.name, this.resetShareCallback);
        }
    }

    displayMember(member: User): boolean {
        return this.$_user.getMyId() != member.userId && !!member.isActive && !member.isFormerTeamMember && (!member.invitation || member.invitation.accepted)
    }

    private checkMember = (teamMember, key?): void => {
        if (teamMember.userId != this.$_user.getMyId() && !!teamMember.isActive && !teamMember.isFormerTeamMember && (!teamMember.invitation || teamMember.invitation.accepted == true)) {
            teamMember.sharedChecked = true;
        }
    }

    private uncheckMember = (teamMember, key?): void => {
        teamMember.sharedChecked = false;
    }

    selectAll(force?: boolean): void {
        for (let member of this.subject.teamMembers) {
            !!this.select && force != false ? this.checkMember(member) : this.uncheckMember(member);
        }
    }
}

function export_func(): ng.IDirective {
    return {
        restrict: 'E',
        templateUrl: 'app/common/directive/team/templates/shareDropdown.directive.html',
        replace: true,
        controller: EcvShareDropdown,
        controllerAs: 'shareDropdownVm',
        scope: true,
        bindToController: {
            'subject': '=ecvSubject',
            'callbackRegistrar': '=?ecvCallbackRegistrar',
            'name': '@?ecvName'
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: IEcvShareDropdown): void => {
            controller.init();
        }
    };
}

angular.module('eCareVault.common.directives').directive('ecvShareDropdown', export_func);
